package com.anjuros.website.templates.template1.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.template1.modules.Template1Section
import com.anjuros.website.templates.template1.modules.Template1Theme
import com.anjuros.website.templates.template1.modules.getColor
import com.anjuros.website.templates.template1.styles.Template1SectionTitleStyle
import com.anjuros.website.templates.template1.util.ResKey
import com.anjuros.website.templates.template1.util.Template1Constants.FONT_FAMILY
import com.anjuros.website.templates.template1.util.Template1ObserverViewportEntered
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text



@Composable
fun Template1SectionTitle(
    badge: ResKey,
    title: ResKey,
    text: ResKey,
    darkMode:Boolean = false,
) {
    var width by remember { mutableStateOf(0.px) }

    Template1ObserverViewportEntered(
        sectionId = title.keyName,
        distanceFromTop = 400.0,
        onViewportEnteredLambda = {
            width = 42.px
        }
    )
    Column(
        modifier = Modifier
            .id(title.keyName)
            .fillMaxWidth()
            .padding(leftRight = 10.px)
            .maxWidth(800.px),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {

        Row(
            verticalAlignment = Alignment.CenterVertically
        ) {

            Box(
                modifier = Modifier
                    .width(width)
                    .transition(
                        Transition.of(
                            "width",
                            400.ms
                        )
                    )
                    .height(1.px)
                    .backgroundColor(
                        if(darkMode) Colors.White else
                        Template1Theme.Secondary.getColor()
                    )
            )



            SpanText(
                LocalText(badge),
                Modifier
                    .fontSize(13.px)
                    .margin(topBottom  =14.px)
                    .fontWeight(FontWeight.SemiBold)
                    .letterSpacing(2.px)
                    .textTransform(TextTransform.Uppercase)
                    .color(
                        if(darkMode) Colors.White else
                        Template1Theme.Secondary.getColor()
                    )
            )


            Box(
                modifier = Modifier
                    .width(width)
                    .transition(
                        Transition.of(
                            "width",
                            400.ms
                        )
                    )
                    .height(1.px)
                    .backgroundColor(
                        if(darkMode) Colors.White else
                        Template1Theme.Secondary.getColor()
                    )
            )
        }


        H2(
            attrs = Template1SectionTitleStyle.toModifier()
                .margin(top = 18.px)
                .fontWeight(FontWeight.Normal)
                .lineHeight(1.1)
                .textAlign(TextAlign.Center)
                .color(
                    Template1Theme.Primary.getColor()
                )
                .margin(0.px)
                .toAttrs()
        ) {
            Text(LocalText(title))
        }


        P(
            attrs = Modifier
                .maxWidth(650.px)
                .margin(top = 18.px)
                .fontSize(18.px)
                .lineHeight(30.px)
                .fontWeight(FontWeight.Normal)
                .textAlign(TextAlign.Center)
                .color(
                    if(darkMode) Colors.White else
                    Template1Theme.SectionSubtitle.rgb
                )
                .margin(0.px)
                .toAttrs()
        ) {
            Text(LocalText(text))
        }
    }
}